import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import type { NewServiceVisitType, VisitTypeErrorState } from '../types'

type UpdateServiceTypesArgs = {
  serviceTypes: NewServiceVisitType[]
  localErrors: VisitTypeErrorState[]
  isSomeVisibilityTypeAllOrNew: boolean
  hasInvalidCombination: boolean
}

export const updateServiceTypes = ({
  serviceTypes,
  localErrors,
  isSomeVisibilityTypeAllOrNew,
  hasInvalidCombination,
}: UpdateServiceTypesArgs): NewServiceVisitType[] =>
  serviceTypes.map((serviceType) => {
    const correctData = localErrors.find((errorConfig) => errorConfig.id === serviceType.VisitTypeId)

    let visibilityTypeError = ''

    if (hasInvalidCombination && serviceType.VisibilityType === 'established') {
      visibilityTypeError = getUserFriendlyErrorMessage(errorCodes.SET_ONE_VISIBILITY_AS_ALL_OR_NEW)
    } else if (!isSomeVisibilityTypeAllOrNew) {
      visibilityTypeError = getUserFriendlyErrorMessage(errorCodes.SET_ONE_VISIBILITY_AS_ALL_OR_NEW)
    }

    return {
      ...serviceType,
      errors: {
        ...(correctData ? correctData.errors : serviceType.errors),
        visibilityTypeError,
      },
    }
  })
